import { Flex } from '@chakra-ui/react'

export default Flex
